module.exports = __webpack_public_path__ + "assets/asset_circle.769d3349.svg";